import React from "react";

export function FeaturedGrants() {
  return (
    <div className="fqxi-shortcodes-featuredGrants"></div>
  );
}
